export default __webpack_public_path__ + "static/media/environment02.28e08700.png";